var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-78.082334,-72.287719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3770",
    transform: "matrix(0.36516849,0,0,0.36516849,-172.07155,-113.49881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g726",
    transform: "matrix(1.3333333,0,0,-1.3333333,728.50778,530.50717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path728",
    fill: "#231F20",
    d: "M62.898-32.994v-0.598c-0.056-4.023-0.59-8.079-1.725-11.93 c-1.047-3.915-2.664-7.63-4.762-11.08c-2.046-3.49-4.561-6.695-7.485-9.469c-2.86-2.834-6.125-5.275-9.668-7.231 c-3.482-1.982-7.285-3.486-11.196-4.481c-3.911-0.987-7.939-1.47-11.963-1.416c-4.052,0.028-8.075,0.626-11.96,1.761 c-3.885,1.045-7.628,2.664-11.053,4.733c-3.488,2.038-6.687,4.563-9.497,7.481c-2.834,2.862-5.275,6.121-7.203,9.666 c-2.01,3.512-3.516,7.283-4.479,11.198c-1.019,3.907-1.5,7.933-1.418,11.99c0.028,4.023,0.628,8.051,1.735,11.934 c1.075,3.883,2.69,7.624,4.76,11.084c2.038,3.458,4.563,6.657,7.481,9.467c2.862,2.834,6.121,5.272,9.637,7.2 c3.518,2.013,7.317,3.512,11.228,4.479c3.883,1.021,7.935,1.502,11.96,1.417c4.053-0.028,8.084-0.595,11.935-1.732 c3.911-1.074,7.626-2.662,11.084-4.759C43.799,4.68,47,2.155,49.776-0.734c2.836-2.892,5.271-6.154,7.229-9.668 c1.986-3.518,3.486-7.287,4.477-11.224C62.444-25.314,62.934-29.167,62.898-32.994"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10292",
    transform: "matrix(0,-1.7969749,-1.7969749,0,1366.4218,1211.1322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g37760",
    transform: "translate(-1.9355985,-0.03306347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2137-2",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.4706,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M352.841,351.525l-11.672-8.837l11.672-8.838V351.525z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2139-8",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.4151,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M353.429,339.279h17.833v6.817h-17.833V339.279z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDown);
export default __webpack_public_path__ + "static/media/btnDown.e90f6c2f08d32e82f68e36fdc084ad64.svg";
export { ForwardRef as ReactComponent };